import { type Struct, validate } from '@subaio/validation'

/** Returns the error message from a Struct error if any, returns `true` otherwise */
export const validateFieldStruct = (value: unknown, struct: Struct<any, any>) => {
	const [err] = validate(value, struct)
	if (err) return err.message
	return true
}
